export const INPUT_OTP_SLOTS = 6;
